export default "__VITE_ASSET__B5V$rRGi__$_?nuxt_component=async&nuxt_component_name=SvgoSecuritasTextLogoBlack&nuxt_component_export=default__"